import React from 'react';
import ReactDOM from 'react-dom';

class Link extends React.Component {
  componentDidMount() {
      
    ReactDOM.findDOMNode(this).addEventListener('click', this.props.onClick);
     
  }
  render() {
    return (this.props.link);
  }
}
export default Link;
